module.exports = __webpack_public_path__ + "static/media/pin.cfff7c58.webp";